import { cva } from 'class-variance-authority'

export const styles = cva('', {
  variants: {
    color: {
      default: '',
      disabled: 'text-neutral-400',
      emphasis: 'text-neutral-700',
      header: 'text-neutral-900',
      link: 'text-neutral-900',
      muted: 'text-neutral-500',
      danger: 'text-danger',
      brand: 'text-brand',
      priority: 'text-priority',
      highlight: 'text-green-100',
      yellow: 'text-yellow-200',
      moss: 'text-moss-200',
      red: 'text-red-200',
      orange: 'text-orange-200',
      green: 'text-green-200',
      inherit: 'text-inherit',
      white: 'text-neutral-0',
    },
    textAlign: {
      center: 'text-center',
      left: 'text-left',
      right: 'text-right',
      inherit: 'text-inherit',
    },
    variant: {
      displayLg: 'display-lg',
      displayMd: 'display-md',
      displaySm: 'display-sm',
      displayXs: 'display-xs',
      displayXxs: 'display-xxs',
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      eyebrow: 'eyebrow',
      labelLg: 'label-lg',
      labelMd: 'label-md',
      labelSm: 'label-sm',
      labelXs: 'label-xs',
      bodyLg: 'body-lg',
      bodyMd: 'body-md',
      bodySm: 'body-sm',
      bodyXs: 'body-xs',
      popupLink: `
          secondary-link
          border-b-2
          border-green-50
          border-dotted
        `,
    },
    underlined: {
      true: `
        inline
        underline
        decoration-dotted
        decoration-green-50
        underline-offset-4
        cursor-pointer
        w-fit
        leading-[150%]
      `,
      false: '',
    },
  },
  defaultVariants: {
    color: 'default',
    textAlign: 'left',
    variant: 'bodySm',
    underlined: false,
  },
  compoundVariants: [
    {
      variant: [
        'displayLg',
        'displayMd',
        'displaySm',
        'displayXs',
        'displayXxs',
        'h1',
        'h2',
        'h3',
        'labelLg',
        'labelMd',
        'labelSm',
        'labelXs',
      ],
      color: 'default',
      className: 'text-neutral-900',
    },
  ],
})
